// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"218c89461fc58696143e","655":"04d4c90a2ae0941054a6"}[chunkId] + ".js";
};